import { Rectangle, Vector2 } from "../../math";
import { floor_t } from "./index";
import { TileCoordinates } from "./TileCoordinates";
import { TileTransform } from "./TileTransform";
export var TileRectangle;
(function (TileRectangle) {
    function contains(box, tile) {
        return tile.level == box.level && Rectangle.containsTile(box, tile);
    }
    TileRectangle.contains = contains;
    function containsCoords(box, tile) {
        return tile.level == box.level && Rectangle.contains(box, tile);
    }
    TileRectangle.containsCoords = containsCoords;
    function clampInto(pos, area) {
        return TileCoordinates.lift(Rectangle.clampInto(pos, area), pos.level);
    }
    TileRectangle.clampInto = clampInto;
    function extend(box, padding) {
        return lift(Rectangle.extend(box, padding), box.level);
    }
    TileRectangle.extend = extend;
    function tl(rect) {
        return TileCoordinates.lift(rect.topleft, rect.level);
    }
    TileRectangle.tl = tl;
    function br(rect) {
        return TileCoordinates.lift(rect.botright, rect.level);
    }
    TileRectangle.br = br;
    function tr(rect) {
        return TileCoordinates.lift(Rectangle.topRight(rect), rect.level);
    }
    TileRectangle.tr = tr;
    function bl(rect) {
        return TileCoordinates.lift(Rectangle.bottomLeft(rect), rect.level);
    }
    TileRectangle.bl = bl;
    function center(rect, snap = true) {
        return TileCoordinates.lift(Rectangle.center(rect, snap), rect.level);
    }
    TileRectangle.center = center;
    function fromTile(tile) {
        if (!tile)
            return null;
        return {
            level: tile.level,
            topleft: { x: tile.x, y: tile.y },
            botright: { x: tile.x, y: tile.y },
        };
    }
    TileRectangle.fromTile = fromTile;
    function isTile(rect) {
        return Vector2.eq(rect.topleft, rect.botright);
    }
    TileRectangle.isTile = isTile;
    function lift(v, level) {
        return { ...v, level: level };
    }
    TileRectangle.lift = lift;
    function left(rect) {
        return lift(Rectangle.left(rect), rect.level);
    }
    TileRectangle.left = left;
    function right(rect) {
        return lift(Rectangle.right(rect), rect.level);
    }
    TileRectangle.right = right;
    function top(rect) {
        return lift(Rectangle.top(rect), rect.level);
    }
    TileRectangle.top = top;
    function bottom(rect) {
        return lift(Rectangle.bottom(rect), rect.level);
    }
    TileRectangle.bottom = bottom;
    function from(...points) {
        return lift(Rectangle.from(...points), Math.min(...points.map(p => p.level)));
    }
    TileRectangle.from = from;
    function extendTo(rect, tile) {
        return lift(Rectangle.extendTo(rect, tile), rect.level);
    }
    TileRectangle.extendTo = extendTo;
    function extendToRect(rect, other) {
        return lift(Rectangle.extendToRect(rect, other), rect.level);
    }
    TileRectangle.extendToRect = extendToRect;
    function translate(rect, off) {
        return lift(Rectangle.translate(rect, off), rect.level);
    }
    TileRectangle.translate = translate;
    function transform(rect, trans) {
        let norm = TileTransform.normalize(trans);
        return lift(Rectangle.transform(rect, norm.matrix), floor_t.clamp(rect.level + norm.level_offset));
    }
    TileRectangle.transform = transform;
    function equals(a, b) {
        return (a == b) || (!!a && !!b && Rectangle.equals(a, b) && a.level == b.level);
    }
    TileRectangle.equals = equals;
})(TileRectangle || (TileRectangle = {}));
